module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "agent-list"
    }
  }, [_c('section', {
    staticClass: "content-toolbar"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.displayAgentCreationBox
    }
  }, [_vm._v("\n      Ajouter un agent\n    ")])]), _vm._v(" "), _c('message', {
    attrs: {
      "obj": _vm.agents.message,
      "hide-mutation-type": "CLEAR_AGENTS_MESSAGE"
    }
  }), _vm._v(" "), (_vm.agents.passwordChangeModal.visible) ? _c('change-password-modal', {
    attrs: {
      "hide-dispatch-action": "closePasswordChangeModal",
      "change-dispatch-action": "changeAgentPassword",
      "can-only-exit-modal": _vm.agents.passwordChangeModal.canOnlyExitModal,
      "is-loading": _vm.agents.passwordChangeModal.loading,
      "message": _vm.agents.passwordChangeModal.message,
      "selected-person": _vm.selectedAgent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConfirmModal) ? _c('deactivation-modal', {
    attrs: {
      "title": "Désactivation d'un agent",
      "data": _vm.selectedAgent
    },
    on: {
      "close": function($event) {
        _vm.showConfirmModal = false
      },
      "confirm": _vm.deactivateAgent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.agents.isActiveCreatedAgentModal) ? _c('person-create-view', {
    on: {
      "close": _vm.resetCreateModal,
      "confirm": _vm.createAgent
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedAgents), function(a) {
    return _c('content-row', {
      attrs: {
        "is-open": _vm.selectedAgent.id === a.id,
        "mark-as-deactivated": !a.actif
      },
      on: {
        "open": function($event) {
          _vm.openAgentDetails(a)
        },
        "close": function($event) {
          _vm.closeAgentDetails()
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "main-close"
      },
      slot: "main-close"
    }, [_c('div', {
      staticClass: "col-sm-5 right-separator"
    }, [_c('div', {
      staticClass: "title-item"
    }, [_vm._v("PRÉNOM, NOM")]), _vm._v(" "), _c('div', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(a.prenom) + " " + _vm._s(a.nom))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 right-separator"
    }, [_c('div', {
      staticClass: "title-item"
    }, [_vm._v("DERNIÈRE TOURNÉE")]), _vm._v(" "), (a.nomDerniereTournee !== null && a.nomDerniereTournee !== undefined) ? _c('ul', [_c('li', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(a.nomDerniereTournee))]), _vm._v(" "), _c('li', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(_vm._f("dateFormatter")(a.dateDerniereTournee)))]), _vm._v(" "), (a.profile === 'Novice') ? _c('li', {
      staticClass: "text-item"
    }, [_vm._v("\n            " + _vm._s(a.progressLastTournee ? a.progressLastTournee : 0) + "%\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!a.nomDerniereTournee) ? _c('div', {
      staticClass: "text-item"
    }, [_c('span', {
      staticClass: "no-data"
    }, [_vm._v("-")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "title-item"
    }, [_vm._v("DERNIÈRE ACTIVITÉ")]), _vm._v(" "), (a.lastActivity) ? _c('div', {
      staticClass: "text-item last-activity",
      class: _vm.getLastActivityClass(a.lastActivity)
    }, [_c('div', {
      staticClass: "pastille"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateFormatterLastActivity")(!a.lastActivity ? '' : a.lastActivity)))])]) : _vm._e(), _vm._v(" "), (!a.lastActivity) ? _c('div', {
      staticClass: "text-item last-activity"
    }, [_c('span', {
      staticClass: "no-data"
    }, [_vm._v("-")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "main-open"
      },
      slot: "main-open"
    }, [_c('div', {
      staticClass: "col-sm-4 item-details"
    }, [_c('div', {
      staticClass: "col-sm-6 col--noLeftPadding"
    }, [_c('div', {
      staticClass: "title-item"
    }, [_vm._v("PRÉNOM")]), _vm._v(" "), (_vm.editingAgentId !== a.id) ? _c('div', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(a.prenom))]) : _vm._e(), _vm._v(" "), (_vm.editingAgentId === a.id) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edit.prenom),
        expression: "edit.prenom"
      }],
      staticClass: "col-sm-12 form-control input-edit",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.edit.prenom)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.edit, "prenom", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v("\n            " + _vm._s(_vm.prenomValidationMessage) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 col--noRightPadding"
    }, [_c('div', {
      staticClass: "title-item"
    }, [_vm._v("NOM")]), _vm._v(" "), (_vm.editingAgentId !== a.id) ? _c('div', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(a.nom))]) : _vm._e(), _vm._v(" "), (_vm.editingAgentId === a.id) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edit.nom),
        expression: "edit.nom"
      }],
      staticClass: "col-sm-12 form-control input-edit",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.edit.nom)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.edit, "nom", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "error-message"
    }, [_vm._v("\n            " + _vm._s(_vm.nomValidationMessage) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 col--noLeftPadding"
    }, [_c('div', {
      staticClass: "title-item topSpace"
    }, [_vm._v("LOGIN")]), _vm._v(" "), (_vm.editingAgentId !== a.id) ? _c('div', {
      staticClass: "text-item break-word"
    }, [_vm._v(_vm._s(a.login))]) : _vm._e(), _vm._v(" "), (_vm.editingAgentId === a.id) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edit.login),
        expression: "edit.login"
      }],
      staticClass: "col-sm-12 form-control input-edit",
      attrs: {
        "type": "text",
        "disabled": true
      },
      domProps: {
        "value": (_vm.edit.login)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.edit, "login", $event.target.value)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 col--noRightPadding"
    }, [_c('div', {
      staticClass: "title-item topSpace"
    }, [_vm._v("MOT DE PASSE")]), _vm._v(" "), _c('div', {
      staticClass: "text-item text-item--password"
    }, [_vm._v("********")]), _vm._v(" "), (_vm.editingAgentId === a.id) ? _c('a', {
      staticClass: "change-password",
      on: {
        "click": function($event) {
          _vm.displayChangePasswordModal()
        }
      }
    }, [_vm._v("Modifier")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col--noLeftPadding"
    }, [_c('div', {
      staticClass: "title-item topSpace"
    }, [_vm._v("PROFIL")]), _vm._v(" "), (_vm.editingAgentId !== a.id) ? _c('div', {
      staticClass: "text-item"
    }, [(_vm.editingAgentId !== a.id) ? _c('div', {
      staticClass: "text-item"
    }, [_vm._v(_vm._s(a.profile))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editingAgentId === a.id) ? _c('div', {
      staticClass: "col-sm-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edit.profile),
        expression: "edit.profile"
      }],
      attrs: {
        "type": "radio",
        "id": "expert",
        "value": "Expert"
      },
      domProps: {
        "checked": _vm._q(_vm.edit.profile, "Expert")
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.edit, "profile", "Expert")
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "expert"
      }
    }, [_vm._v("Expert")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edit.profile),
        expression: "edit.profile"
      }],
      attrs: {
        "type": "radio",
        "id": "novice",
        "value": "Novice"
      },
      domProps: {
        "checked": _vm._q(_vm.edit.profile, "Novice")
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.edit, "profile", "Novice")
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "novice"
      }
    }, [_vm._v("Novice")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 item-details left-separator right-separator"
    }, [_c('div', [_c('div', {
      staticClass: "title-item botton-space"
    }, [_vm._v("RÉFÉRENT SUR LES RONDES")]), _vm._v(" "), _c('ul', _vm._l((a.rondesReferent), function(rr) {
      return _c('li', {
        key: _vm.$index,
        staticClass: "text-item"
      }, [_vm._v(_vm._s(rr))])
    }))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 item-details right-separator"
    }, [_c('div', [_c('div', {
      staticClass: "title-item botton-space"
    }, [_vm._v("PLANIFIÉ ACTUELLEMENT SUR")]), _vm._v(" "), _c('ul', _vm._l((a.rondesPlanifies), function(rp) {
      return _c('li', {
        key: _vm.$index,
        staticClass: "text-item"
      }, [_vm._v(_vm._s(rp))])
    }))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 item-details right-separator"
    }, [_c('div', [_c('div', {
      staticClass: "title-item botton-space"
    }, [_vm._v("RONDES DÉJÀ RÉALISÉES")]), _vm._v(" "), _c('ul', _vm._l((a.rondesAlreadyDone), function(re) {
      return _c('li', {
        key: _vm.$index,
        staticClass: "text-item"
      }, [_vm._v(_vm._s(re))])
    }))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 item-details"
    }, [_c('div', {
      staticClass: "title-item"
    }, [_vm._v("DERNIÈRE ACTIVITÉ")]), _vm._v(" "), (a.lastActivity) ? _c('div', {
      staticClass: "text-item last-activity",
      class: _vm.getLastActivityClass(a.lastActivity)
    }, [_c('div', {
      staticClass: "pastille"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateFormatterLastActivity")(!a.lastActivity ? '' : a.lastActivity)))])]) : _vm._e(), _vm._v(" "), (!a.lastActivity) ? _c('div', {
      staticClass: "text-item last-activity"
    }, [_c('span', {
      staticClass: "no-data"
    }, [_vm._v("-")])]) : _vm._e()])]), _vm._v(" "), (_vm.selectedAgent.id === a.id) ? _c('div', {
      attrs: {
        "slot": "bottom-actions"
      },
      slot: "bottom-actions"
    }, [_c('activate-deactivate-button', {
      attrs: {
        "state": !a.actif
      },
      on: {
        "activate": function($event) {
          _vm.activateAgent(a)
        },
        "deactivate": function($event) {
          _vm.showConfirmModal = true
        }
      }
    }), _vm._v(" "), _c('modify-save-button', {
      attrs: {
        "state": _vm.editingAgentId !== a.id
      },
      on: {
        "modify": function($event) {
          _vm.openEditionMode(a)
        },
        "save": function($event) {
          _vm.updateAgentInfo()
        }
      }
    })], 1) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5171036a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/agents/AgentsList.vue
// module id = 1866
// module chunks = 2